export default "__VITE_ASSET__e6c63878__"